module.exports = __webpack_public_path__ + "img/small-4.19af0c3c.jpg";